﻿import * as bootstrap from 'bootstrap';

export function initLeadApproval() {
    setTotalCalculation();
    initLeadAddress();
    initLeadFeedback();
}

function initLeadFeedback() {
    let leadFeedbacks = document.querySelectorAll("button[data-lead-feedback]");
    let leadInput = document.querySelector("#LeadFeedbackModal input[name='LeadItemGuid']");
    let leadItemModalElement = document.getElementById('LeadFeedbackModal');

    if (!leadInput || !leadItemModalElement) {
        // console.warn("Required elements for lead feedback are not present in the DOM.");
        return;
    }

    let leadItemModal = new bootstrap.Modal(leadItemModalElement);

    leadFeedbacks.forEach(element => {
        //add event listener to each button to open modal
        element.addEventListener("click", () => {
            let leadItemId = element.getAttribute("data-lead-feedback");
            leadInput.value = leadItemId;
            leadItemModal.show();
        });
    });

    let leadConfirmButton = document.querySelector("button[data-lead-confirm-choice]");

    if (leadConfirmButton) {
        let leadConfirmAlert = document.querySelector("[lead-confirm-alert]");
        
        let leadRadioButtons = document.querySelectorAll("[data-lead-radio]");
        let radioGroups = [...new Set(Array.from(leadRadioButtons).map(rb => rb.name))]; // get all radio groups

        leadRadioButtons.forEach(element => {
            element.addEventListener("click", () => {
                let allGroupsChecked = radioGroups.every(group => document.querySelector(`input[name="${group}"]:checked`));
                let valueBiggerThanZeroExists = Array.from(leadRadioButtons).some(rb => rb.checked &&  Number(rb.getAttribute("data-lead-radio")) > 0);
                if (allGroupsChecked && valueBiggerThanZeroExists) {
                    leadConfirmButton.disabled = false;
                    leadConfirmAlert.classList.add("d-none");
                } else {
                    leadConfirmButton.disabled = true;
                    leadConfirmAlert.classList.remove("d-none");
                }
            });
        });
    }
}

function setTotalCalculation() {
    let leadContainer = document.getElementById("leadPrintContainer");
    if (leadContainer) {
        let leadRadioButtons = document.querySelectorAll("[data-lead-radio]");
        if (leadRadioButtons.length) {
            leadRadioButtons.forEach(function(element) {
                element.addEventListener("click", function() {
                    let total = 0;
                    // Convert NodeList to Array so we can use Array methods
                    let leadRadioArray = Array.from(leadRadioButtons);

                    //get all checked radio buttons and sum their values
                    leadRadioArray.filter(f => f.checked).map(m => total += parseFloat(m.getAttribute("data-lead-radio"), 10));

                    //convert total to currency format with two decimal places
                    total = total.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });

                    document.querySelector("[data-lead-total]").innerText = total;
                });
            });
        }
    }
}

function initLeadAddress() {
    let inputHideHolders = document.querySelectorAll('[data-input-hide]');
    if (inputHideHolders.length) {
        inputHideHolders.forEach(function(element) {
            element.addEventListener("change", function() {
                let value = this.value;
                let addressHolder = document.querySelector(element.getAttribute('data-input-hide'));
                if (value.length) {
                    addressHolder.classList.add('d-none');
                } else {
                    addressHolder.classList.remove('d-none');
                }
            });
        });
    }
}